import { useAppDispatch } from "../../../app/hooks";
import { changeStep } from "../../../redux/slices/windowSlice";
import Header from "../../Window/Header";
import './style.scss';

const CloseSession = () => {

    const dispatch = useAppDispatch();
    dispatch(changeStep(4));

    return (
        <>
            <Header />
            <div className="end">
                <div className="end_container">
                    <div className="end_wrapper">
                        <h1 className="end_title">Ваш сеанс завершён!</h1>
                        <span className="end_text">Для нового заказа закройте и откройте повторно данное окно.</span>
                    </div>
                </div>
            </div>
        </>
    );
}

export default CloseSession;